






import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class InfoBox extends Vue {
  @Prop({ type: String, default: 'information' }) type!: string
  @Prop({ type: String }) title: string
  @Prop({ type: String, default: 'is-medium' }) size: string

  get boxTitle() {
    return this.title ? this.title : this.$t(`global.info_box.${this.type}`)
  }
}
